<template>
    <div>
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            key-property="categoryId"
            search-url="/category/onSearchAllStatus?categoryTypeCode=SEEDNUMBER&sortField=createAt&"
            create-url="/category/save"
            delete-url="/category/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
        >
        </c-search-form>
        <seed-number-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
        />
    </div>
</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import PondAreaCreate from "./SeedNumberCreate.vue";
import { areaContants } from "@/constants";
import axios from "axios";
import SeedNumberCreate from "@/views/admin/seed_number/SeedNumberCreate";

export default {
    name: "warehouse",
    components: {SeedNumberCreate, PondAreaCreate, CSearchForm },
    data: () => {
        return {
            formName: "Danh sách",
            formCreateName: "Thêm mới",
            category: null,
            visibleCreateDialog: false,
            timeReload: 0,
            fields: [
                {
                    value: "index",
                    text: "lang.common.index",
                    width: "5%",
                    sortable: false,
                    headerStyle: "text-align:center",
                },
                {
                    value: "categoryCode",
                    text: "Số lượng con giống",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "categoryName",
                    text: "Tên",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                // {
                //     value: "parentName",
                //     text: "Ký hiệu",
                //     headerStyle: "text-align:center",
                //     name: "parentName",
                // },
                {
                    value: "status",
                    text: "lang.user.status",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "status",
                    items: areaContants.areaStatus,
                    itemText: "text",
                    itemValue: "value",
                },
                {
                    value: "action",
                    text: "lang.common.actions",
                    sortable: false,
                    compound: true,
                    width: "60px",
                    headerStyle: "text-align:center",
                },
            ],
        };
    },

    created() {
        
    },

    methods: {
        openCreateDialog: function (item = null) {
            if (item == null) {
                this.formCreateName = 'Thêm mới';
               // this.getNextCode();
                this.visibleCreateDialog = true;
                //this.category = item;
            } else {
                this.category = item;
                this.formCreateName = 'Cập nhật';
                this.visibleCreateDialog = true;
            }
        },
        closeCreateDialog: function () {
            this.category = null;
            this.visibleCreateDialog = false;
            this.timeReload = Math.floor(Math.random() * 100);
        },

        getNextCode: function () {
            axios.get(
                    process.env.VUE_APP_API_URL +
                    "/autoIncrease/getNextCharacter?type=SEEDNUMBER"
                )
                .then((data) => {
                    this.category = Object.assign({}, this.category, {"categoryCode": "SEEDNUMBER"+ data, "status": 1})
                    this.visibleCreateDialog = true;
                });
        },
    },

    destroyed() {},
};
</script>
